// title
import HeadingView from "common/views/heading/Heading.view";
import { Fragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import PageConfig from "../page/PageConfig";

export interface IPageInfoProps {
	pageInstance: string;
	pageConfig: PageConfig;
}

export const pageTitle: Fragment<IPageInfoProps> = {
	name: "Page Title",
	component: ({pageInstance, pageConfig}) => (
		<HeadingView viewKey="catalog.title" autoSkeleton={false}>
			<Label k={`panel.${pageInstance}.label`} v={pageConfig.label} />
		</HeadingView>
	)
};



// WEBPACK FOOTER //
// ./src/panels/pageInfo/fragments.tsx